/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimal,
  AmountDecimal$inboundSchema,
  AmountDecimal$Outbound,
  AmountDecimal$outboundSchema,
} from "./amountdecimal.js";

/**
 * Represents a modifier or option applied to a line item.
 */
export type CreatePaymentLinkLineItemOption = {
  /**
   * The name of the option or modifier.
   */
  name: string;
  /**
   * The quantity of this option.
   */
  quantity: number;
  /**
   * Optional price modification applied by this option. Can be positive, negative, or zero.
   */
  priceModifier?: AmountDecimal | undefined;
  /**
   * Optional list of images associated with this line item option.
   */
  imageIDs?: Array<string> | undefined;
  /**
   * Optional group identifier to categorize related options (e.g., 'toppings').
   */
  group?: string | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItemOption$inboundSchema: z.ZodType<
  CreatePaymentLinkLineItemOption,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  quantity: z.number().int(),
  priceModifier: AmountDecimal$inboundSchema.optional(),
  imageIDs: z.array(z.string()).optional(),
  group: z.string().optional(),
});
/** @internal */
export type CreatePaymentLinkLineItemOption$Outbound = {
  name: string;
  quantity: number;
  priceModifier?: AmountDecimal$Outbound | undefined;
  imageIDs?: Array<string> | undefined;
  group?: string | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItemOption$outboundSchema: z.ZodType<
  CreatePaymentLinkLineItemOption$Outbound,
  z.ZodTypeDef,
  CreatePaymentLinkLineItemOption
> = z.object({
  name: z.string(),
  quantity: z.number().int(),
  priceModifier: AmountDecimal$outboundSchema.optional(),
  imageIDs: z.array(z.string()).optional(),
  group: z.string().optional(),
});

export function createPaymentLinkLineItemOptionToJSON(
  createPaymentLinkLineItemOption: CreatePaymentLinkLineItemOption,
): string {
  return JSON.stringify(
    CreatePaymentLinkLineItemOption$outboundSchema.parse(
      createPaymentLinkLineItemOption,
    ),
  );
}
export function createPaymentLinkLineItemOptionFromJSON(
  jsonString: string,
): SafeParseResult<CreatePaymentLinkLineItemOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreatePaymentLinkLineItemOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreatePaymentLinkLineItemOption' from JSON`,
  );
}
